<template>
  <div>
    <v-dialog
      v-model="dialogVisible"
      width="300">
      <EditCategoryDialog/>
    </v-dialog>
    <v-list-item>
      <v-list-item-content>
        <v-list-item-title class="title">
          Спиок категорий
        </v-list-item-title>
        <v-list-item-subtitle>
          Выбрать категорию
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

    <v-divider></v-divider>

    <v-list-item-group v-model="group" color="indigo">
      <v-list-item
        v-for="(item, i) in categories"
        :key="i"
        @click="selectCategory(item.id)"
      >
        <v-list-item-content>
          <v-list-item-title>{{ item.caption }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list-item-group>

    <v-btn fixed bottom dark fab right color="pink" small @click="showEditCategoryDialog">
      <v-icon>mdi-plus</v-icon>
    </v-btn>
  </div>
</template>

<script>
import {
  LOAD_CATEGORIES_ACTION, SET_EDITED_CATEGORY_ACTION, SELECT_CATEGORY_ACTION,
} from '../store/actions/categories-actions';
import EditCategoryDialog from './EditCategoryDialog.vue';

export default {
  name: 'categories-list',
  components: { EditCategoryDialog },
  comments: { EditCategoryDialog },
  data: () => ({
    group: null,
  }),
  computed: {
    categories() {
      return this.$store.getters.categoriesList;
    },
    dialogVisible() {
      return this.$store.getters.categoryForEdit !== undefined;
    },
    selectedCategory() {
      return this.$store.getters.selectedCategory;
    },
  },
  mounted() {
    this.$store.dispatch(LOAD_CATEGORIES_ACTION);
  },
  methods: {
    selectCategory(categoryId) {
      this.$store.dispatch(SELECT_CATEGORY_ACTION, categoryId);
    },
    showEditCategoryDialog() {
      this.$store.dispatch(SET_EDITED_CATEGORY_ACTION, {});
    },
  },
};
</script>

<style scoped>
</style>
